'use client';

import { useSyncExternalStore } from 'react';

const subscribeToHydration = () => () => {};
const getHydratedSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * Keeps the server render and the first hydration render aligned, then reports
 * hydration on the follow-up client render. Disabled callers stay on the server
 * snapshot and do not receive an extra hydration update.
 */
export default function useHydratedWhenEnabled(enabled: boolean) {
  return useSyncExternalStore(
    subscribeToHydration,
    enabled ? getHydratedSnapshot : getServerSnapshot,
    getServerSnapshot,
  );
}
